import useApiQuery from 'shared/hooks/use-api-query';
import {PaymentMethodProps} from '../types';

const usePaymentMethodsSelect = () => {
  const {data = [], ...rest} = useApiQuery<PaymentMethodProps[]>({
    url: '/payment-methods/all',
  });

  return {
    ...rest,
    data: data?.map((paymentMethod: PaymentMethodProps) => ({
      label: paymentMethod.name,
      value: paymentMethod.id,
    })),
  };
};

export default usePaymentMethodsSelect;
